import React from 'react';
import { VenueAnalysisData } from 'widgets/venueAnalysis/venueAnalysisAggregatedData';

import { VenueAnalysisVenueDisplayData } from 'widgets/venueAnalysis/grid/gridData';
import { VenueAnalysisBar } from 'widgets/venueAnalysis/grid/VenueAnalysisBar';

import './VenueExecCapsuleContentFront.scss';
import { useDelayedHover } from '@instinet-analytics/core-lib';
import classNames from 'classnames';
import { toVenueExecCapsuleData } from 'widgets/venueAnalysis/capsules/venueExecCapsule/components/content/venueExecCapsuleData';

const BarExpandThresholdPercent = 50;

export interface VenueExecCapsuleContentFrontProps {
    data: VenueAnalysisData;
    showOrderData: boolean;
    onBarClicked: (
        view: 'back-historical' | 'back-today' | 'back-order'
    ) => void;
}

export function VenueExecCapsuleContentFront(
    props: VenueExecCapsuleContentFrontProps
) {
    const { data, showOrderData, onBarClicked } = props;

    const [onMouseEnter, onMouseLeave, flippable] = useDelayedHover(0);

    const width = 200;

    const { histDisplayData, todayDisplayData, orderDisplayData } =
        toVenueExecCapsuleData(data, 5);

    const cssClasses = classNames(
        'VenueExecCapsuleContentFront',
        flippable && 'flippable'
    );

    return (
        <div className={cssClasses}>
            <Bar
                className="historical-bar"
                label="Historical"
                venues={histDisplayData}
                onClick={() => onBarClicked('back-historical')}
            />
            <Bar
                className="today-bar"
                label="Today"
                venues={todayDisplayData}
                onClick={() => onBarClicked('back-today')}
            />
            {showOrderData && (
                <Bar
                    className="order-bar"
                    label="Order"
                    venues={orderDisplayData}
                    onClick={() => onBarClicked('back-order')}
                />
            )}
        </div>
    );

    function Bar(props: {
        className: string;
        label: string;
        venues: VenueAnalysisVenueDisplayData[];
        onClick: () => void;
    }) {
        const { label, venues, onClick, className } = props;
        return (
            <div
                className={`bar ${className}`}
                onClick={onClick}
                onMouseEnter={onMouseEnter}
                onMouseLeave={onMouseLeave}
            >
                <div className="label">{label}</div>
                <div className="content">
                    {venues.map((venueExec) => (
                        <VenueAnalysisBar
                            width={width}
                            data={venueExec}
                            showVenues={false}
                            key={venueExec.name}
                            highlightMode={'VenueType'}
                            highlightOnHover={true}
                            barExpandThresholdPercent={
                                BarExpandThresholdPercent
                            }
                        />
                    ))}
                </div>
            </div>
        );
    }
}
